module.exports = __webpack_public_path__ + "img/IIToolkitPalette.7f4f7ddc.jpg";